import { cn } from "@lib/utils";
import * as React from "react";

const BaseInput = React.forwardRef(
	({ className, type = "text", ...props }, ref) => {
		return (
			<input
				type={type}
				ref={ref}
				className={cn(
					"underline-input flex min-h-[48px] w-full border-0 border-b-2 border-[#063447] bg-transparent px-0 py-2 text-base text-stone-900 caret-[#063447] placeholder:text-stone-500 transition-colors focus:border-[#063447] focus-visible:outline-none disabled:border-stone-200 disabled:text-stone-400",
					className,
				)}
				{...props}
			/>
		);
	},
);
BaseInput.displayName = "BaseInput";

export { BaseInput };
